import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "constants/queryKeys";
import { errorModal } from "modules/error/ErrorHandlingModals";
import { ErrorResponse } from "types";

import { getSupplierById } from "../api/getSupplierById";

export const useGetSupplierById = (id: string | undefined, queryOptions?: { suspense: boolean }) => {
  return useQuery({
    queryKey: [QUERY_KEYS.supplier_by_id, id],
    queryFn: () => getSupplierById(id),
    enabled: Boolean(id),
    onError: (error: ErrorResponse) => errorModal(error),
    staleTime: Infinity,
    useErrorBoundary: true,
    ...queryOptions
  });
};
